export default __webpack_public_path__ + "static/media/airdockz-cbb-4.b75f0551.png";